export interface Level {
    id: number;
    sentence: string;
    difficulty?: 'easy' | 'medium' | 'hard';
  }
  
  export const gameLevels: Level[] = [
        {
          id: 1,
          sentence: "Call me Ishmael.",
          difficulty: 'easy'
        },
        {
          id: 2,
          sentence: "It was the best of times, it was the worst of times.",
          difficulty: 'easy'
        },
        {
          id: 3,
          sentence: "In a hole in the ground there lived a hobbit.",
          difficulty: 'medium'
        },
        {
          id: 4,
          sentence: "All happy families are alike; each unhappy family is unhappy in its own way.",
          difficulty: 'medium'
        },
        {
          id: 5,
          sentence: "So we beat on, boats against the current, borne back ceaselessly into the past.",
          difficulty: 'hard'
        }
  ];